import { PackageOpen, ClipboardList, Send, Phone } from "lucide-react";
import Reveal from "@/components/Reveal";
import { BIZ } from "@/constants/content";

const STEPS = [
  { icon: ClipboardList, t: "Fill out the intake form", c: "List every handpiece you're sending — we'll know what to expect." },
  { icon: PackageOpen, t: "Box them up & ship them over", c: "We'll walk you through packing and getting them to our bench." },
  { icon: Send, t: "Repaired & shipped back to your office", c: "Once we get the handpieces in, it's 24–72 hours until they're on the way home — tested and warrantied." },
];

export default function ShipIn() {
  return (
    <section id="shipin" className="relative overflow-hidden bg-white py-16 sm:py-20" data-testid="shipin-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-10 rounded-[26px] border border-brandsky/25 bg-gradient-to-br from-brandsky-soft/70 via-white to-white p-8 shadow-[0_14px_50px_rgba(22,50,79,0.08)] sm:p-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <Reveal>
              <p className="eyebrow text-brandsky-deep">Shipping in from out of town</p>
              <h2 className="font-display mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                Not from Buffalo?
                <br />
                Ship your handpieces to us.
              </h2>
              <p className="mt-4 max-w-md text-[15.5px] leading-relaxed text-slate-600" data-testid="shipin-copy">
                Fill out the form below and we'll show you how to ship your handpieces over to us for repair — ship
                in, ship out, anywhere in the country. Once we get the handpieces in, it's 24–72 hours until they're
                shipped back to your office.
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <a
                  href="#intake"
                  data-testid="shipin-intake-button"
                  className="btn-lift inline-flex items-center gap-2.5 rounded-full bg-ink px-7 py-3.5 text-[14.5px] font-bold text-white shadow-[0_14px_34px_rgba(22,50,79,0.3)] hover:bg-abyss"
                >
                  Start a ship-in intake
                </a>
                <a
                  href={BIZ.jacob.tel}
                  data-testid="shipin-call-button"
                  className="inline-flex items-center gap-2 text-[13.5px] font-bold text-ink link-underline"
                >
                  <Phone className="h-4 w-4 text-brandsky-deep" />
                  Questions? Call (716) 256-6630
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <ol className="space-y-3">
                {STEPS.map((s, i) => (
                  <li
                    key={s.t}
                    className="flex items-start gap-4 rounded-2xl border border-ink/10 bg-white p-5 transition-all duration-300 hover:-translate-y-0.5 hover:border-brandsky/50 hover:shadow-md"
                    data-testid={`shipin-step-${i + 1}`}
                  >
                    <span className="rounded-xl bg-brandsky-soft p-2.5">
                      <s.icon className="h-5 w-5 text-brandsky-deep" />
                    </span>
                    <span>
                      <span className="flex items-center gap-2">
                        <span className="font-mono text-[11px] font-bold text-brandsky-deep">{`0${i + 1}`}</span>
                        <span className="text-[15px] font-bold text-ink">{s.t}</span>
                      </span>
                      <span className="mt-1 block text-[13.5px] leading-relaxed text-slate-500">{s.c}</span>
                    </span>
                  </li>
                ))}
              </ol>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}